export enum SortProperty {
  EntryDate = 'entryDate',
  Amount = 'amount',
}
